import Vue from 'vue'
import VueRouter from 'vue-router'
import { ajax } from "jquery";
import Home from '../views/Home.vue'
import CompanyPerson from '../views/CompanyPerson.vue'
import ChangePasswd from '../views/ChangePasswd.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/home',
    name: 'Home',
    component: Home,
    children: [{
        path: 'changePasswd',
        name: 'ChangePasswd',
        component: ChangePasswd,
        meta: {
            title: '修改密码'
        }
    },
    {
        path: 'companyPolicyAdmin',
        name: 'CompanyPolicyAdmin',
        component: () =>
            import('../views/CompanyPolicyAdmin.vue'),
        meta: {
            title: '添加人员'
        }

    },
    {
        path: 'companyList',
        name: 'CompanyList',
        component: () =>
            import('../views/CompanyList.vue'),
        meta: {
            title: '企业列表'
        }
    },
    {
        path: 'companySub',
        name: 'CompanySub',
        component: () =>
            import('../views/CompanySub.vue'),
        meta: {
            title: '企业列表'
        }
    },
    {
        path: 'companyPerson',
        name: 'PersonList',
        component: CompanyPerson,
        meta: {
            title: '人员列表'
        }
    },
    {
        path: 'companyCount',
        name: 'CompanyCount',
        component: () =>
            import('../views/CompanyCount.vue'),
        meta: {
            title: '区间统计'
        }
    },
    {
        path: 'companyStat',
        name: 'CompanyStat',
        component: () =>
            import('../views/CompanyStat.vue'),
        meta: {
            title: '企业统计'
        }

    }]
},
{
    path: '/branch',
    name: 'branch',
    component: () =>
        import('../views/Branch.vue'),
    children: [{
        path: 'branchCompanys',
        name: 'BranchCompanys',
        component: () =>
            import('../views/BranchCompanys.vue'),
        meta: {
            title: '企业列表'
        }
    },{
        path: 'branchPolicy',
        name: 'BranchPolicy',
        component: () =>
            import('../views/BranchPolicy.vue'),
        meta: {
            title: '人员列表'
        }
    },{
        path: 'statistList',
        name: 'StatistList',
        component: () =>
            import('../views/StatistList.vue'),
        meta: {
            title: '统计列表'
        }
    },{
        path: 'changeBranchPassword',
        name: 'ChangeBranchPassword',
        component: () => import('../views/ChangeBranchPassword.vue'),
        meta: {
            title: '修改密码'
        }
    }]
},
{
    path: '/company',
    name: 'company',
    component: () =>
        import('../views/Company.vue'),
    children: [{
        path: 'companyPolicy',
        name: 'CompanyPolicy',
        component: () =>
            import('../views/CompanyPolicy.vue'),
        meta: {
            title: '添加人员'
        }
    },
    {
        path: 'changePassword',
        name: 'ChangePassword',
        component: ChangePasswd,
        meta: {
            title: '修改密码'
        }
    },
    {
        path: 'companyPerson',
        name: 'CompanyPerson',
        component: CompanyPerson,
        meta: {
            title: '人员列表'
        }
    },
    {
        path: 'companyPersonChange',
        name: 'CompanyPersonChange',
        component:() => import('../views/CompanyPersonChange.vue'),
        meta: {
            title: '人员变更'
        }
    }, 
    {
        path: 'companyStatDay',
        name: 'CompanyStatDay',
        component: () =>
            import('../views/CompanyStatDay.vue'),
        meta: {
            title: '每日统计'
        }
    }
    ]
},

{
    path: '/',
    name: 'Login',
    component: () =>
        import('../views/Login.vue'),
    meta: {
        title: '登录'
    }
}
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeResolve((to, from, next) => {
    let isAuthenticated = sessionStorage.getItem("loginState")
    let userType = sessionStorage.getItem("userType")
    console.log("userType",sessionStorage.getItem("userType"))
    let checkType = (userType == 0 ? 'checklogin' : 'checkarealogin')
    if (to.name !== 'Login') {
        ajax({
            url: "/AdminTravel/TravelCompanylogin.ashx?type=" + checkType,
            method: "POST",
            headers: {
                "content-type": "application/x-www-form-urlencoded",
            }
        })
            .then((res) => {
                if (res.result !== "success") {

                    console.log("状态异常:" + JSON.stringify(res))
                    next({ name: 'Login' })

                } else {
                    // console.log("res:", res);
                    // 登录时限内, 设置userInfo 并 更改登录状态值 loginState

                    sessionStorage.setItem("loginState", "true")
                    sessionStorage.setItem("companyid", res.companyid)
                    sessionStorage.setItem("companyname", res.companyname)


                    isAuthenticated = "true";
                    if (isAuthenticated != "true") {
                        // 登录时限失效时, 清空userInfo 并 更改登录状态值 loginState
                        sessionStorage.setItem("loginState", false)
                        isAuthenticated = "false";
                        sessionStorage.removeItem("userInfo")

                        alert('登录时效已过期,请重新登录');
                        next({ name: 'Login' })
                    }
                    next()


                }

            })
            .catch((err) => {
                console.log("网络异常:", JSON.stringify(err))
            });
    } else next()
})

router.afterEach((to, from) => {
    document.title = to.meta.title
})


export default router